import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-784f8d15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "ResultsContainer" }
const _hoisted_2 = {
  key: 0,
  class: "ContainerTimeSelector flex mt-3 flex-wrap md:p-4 br16"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "ContainerTimeSelector flex justify-center items-center mt-3 md:p-4 br16 error-message text-center w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hours.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (_ctx.setActiveHour(hour.value)),
              class: _normalizeClass([{ active: _ctx.selectedHour == hour.value }, "cursor-pointer h-12 rounded-lg flex justify-center items-center text-sm flex-shrink basis-1/4"])
            }, [
              _createElementVNode("div", null, _toDisplayString(hour.label), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t("search_no_resources_found")), 1)
        ]))
  ]))
}